module.exports = __webpack_public_path__ + "static/mobile-0b96ece83c7ca297bdb4f34432eefaf6.jpg";